import React from 'react';

import { useClinica } from '../../../hooks/clinica';

import { RelatorioHeader } from './styles';

type ComponentProps = {
  dataImpressao?: string;
  titulo: string;
};

const HeaderRelatorio: React.FC<ComponentProps> = ({
  dataImpressao,
  titulo,
}) => {
  const { imagensClinica } = useClinica();

  const logo =
    imagensClinica.find(img => img.nome === 'logoRelatorio')?.arquivo_url || '';

  return (
    <>
      <div className="bg-white border p-2 my-3">
        <img
          src={logo}
          style={{ width: '100%', maxWidth: '200px' }}
          alt="Agenda Facil"
        />{' '}
        {dataImpressao && `Impresso em ${dataImpressao}`}
      </div>

      <RelatorioHeader>{titulo}</RelatorioHeader>
    </>
  );
};

export default HeaderRelatorio;
